export default {
  metadata: {
    version: '1.0.0',
    id: 'bottom-footer-link-item-1.0.0',
    name: 'JDSBottomFooterLinkItem',
    platform: 'web'
  },
  hierarchy: {
    container: ['jds_link', 'jds_divider']
  },
  base: {
    container: {
      gap: '{b_0}'
    },
    jds_divider: {
      pad: 'none',
      orientation: 'vertical'
    },
    jds_link: {
      kind: 'submenu',
      textAppearance: 'body_xxs'
    }
  },
  variant: {
    separator: {
      false: {
        jds_divider: {
          hidden: true
        }
      }
    }
  },
  api: {
    config: {
      separator: {
        values: [true, false]
      }
    },
    data: {
      jds_link: {
        title: {
          type: 'string',
          name: 'title'
        },
        href: {
          type: 'string',
          name: 'href'
        },
        newTab: {
          type: 'boolean',
          name: 'newTab',
          platform: 'web'
        },
        routerLinkProps: {
          type: 'RouterLinkProps',
          name: 'routerLinkProps',
          platform: 'angular'
        },
        onClick: {
          type: 'event',
          name: 'onClick'
        },
        provider: {
          type: 'object',
          name: 'provider',
          platform: 'react'
        }
      }
    },
    a11y: {
      jds_link: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
